export const roundNumber = (number, extended = false) => {
  /*
    Return
     either the count if the amount is under 1000: 734, 34
     or     the count rounded if it's over 1000: 3k, 2.7k, 8,9k
   */

  if (number < 1000) {
    return number.toString();
  }

  // some js magic
  // rounds the number to one decimal place if it doesn't end on 0
  // e.g:  5327 --> 5.327 -> 5,3, 5034 --> 5.034 --> 5
  if (number < 1000000) {
    const roundedCount = +(Math.round(number / 1000 + 'e+1') + 'e-1');
    return `${roundedCount}k`;
  }

  const roundedCount = +(Math.round(number / 1000000 + 'e+1') + 'e-1');
  return `${roundedCount}${extended ? ' Million' : 'M'}`;
};
